<template>
  <div :class="_class">
    <!-- @slot  input组件-->
    <slot/>
  </div>
</template>

<script>
  // import Input from '../input/input';
  const name = 'hive-input-group';
  export default {
    name,
    props: {
      collapse: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        curCollapse: this.collapse,
      };
    },
    computed: {
      _class() {
        return [
          name,
          {
            [`${name}__collapse`]: this.curCollapse,
          },
        ];
      },
    },
  };
</script>
